import React, { useContext } from 'react';
import Box from '@material-ui/core/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { CalendarEditAvailabilityContext } from '../../Context';

const useStyles = makeStyles(() => ({
  legend: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
  },
  icon: {
    cursor: 'pointer',
    marginRight: '5px',
  },
  availabilityIcon: {
    color: '#BAE2E7',
  },
  exceptionsIcon: {
    color: '#F39D9D',
    marginLeft: '10px',
  },
}));

const CalendarLegend = () => {
  const {
    showExceptionsOnCalendar,
    setShowExceptionsOnCalendar,
    showAvailabilityOnCalendar,
    setShowAvailabilityOnCalendar,
  } = useContext(CalendarEditAvailabilityContext);
  const classes = useStyles();

  return (
    <>
      <Box display="flex" className={classes.legend}>
        {showAvailabilityOnCalendar ? (
          <CheckCircleIcon
            className={`${classes.icon} ${classes.availabilityIcon}`}
            onClick={() => setShowAvailabilityOnCalendar(false)}
          />
        ) : (
          <RadioButtonUncheckedIcon
            className={`${classes.icon} ${classes.availabilityIcon}`}
            onClick={() => setShowAvailabilityOnCalendar(true)}
          />
        )}
        <Typography variant="caption">All available days</Typography>
        {showExceptionsOnCalendar ? (
          <CheckCircleIcon
            className={`${classes.icon} ${classes.exceptionsIcon}`}
            onClick={() => setShowExceptionsOnCalendar(false)}
          />
        ) : (
          <RadioButtonUncheckedIcon
            className={`${classes.icon} ${classes.exceptionsIcon}`}
            onClick={() => setShowExceptionsOnCalendar(true)}
          />
        )}
        <Typography variant="caption">All exceptions</Typography>
      </Box>
    </>
  );
};

export default CalendarLegend;
